import React, { useEffect, useState } from "react";
import Card from "../../share/cards/Card";
import { ReactComponent as Edit } from "../../../Assets/Image/svg/edit.svg";
import { ReactComponent as ReFetch } from "../../../Assets/Image/svg/reFetch.svg";
import IconButton from "../../share/buttons/IconButton";
import AdminPagination from "../../share/Pageination/AdminPagination";
import { Modal } from "../../share/modal/Modal";
import TicketModal from "../AdminDashboard/TicketModal";
import moment from "jalali-moment";

const SupportTicketTable = ({
    setTicketAnswer,
    TicketAnswer,
    tickets,
    setAnswerId,
}) => {
    const [page, setPage] = useState(0);
    const [coloumn, setColoumn] = useState(3);
    const [edit, setEdit] = useState();
    const [modalData, setModalData] = useState();

    var tableStart = page * coloumn;
    var tableEnd = page * coloumn + coloumn;

    const handleAnswer = (id) => {
        setTicketAnswer(true);
        setAnswerId(id);
    };

    return (
        <div className="mx-24 py-24">
            <Card className="SupportTicketTable-card SupportTicketTable-header ">
                <div>نام تیکت</div>
                <div>تاریخ ارسال </div>
                <div>وضعیت </div>
                <div></div>
            </Card>
            {tickets?.results.map((i) => (
                <Card
                    key={i.id}
                    className="SupportTicketTable-card SupportTicketTable-body  my-4"
                >
                    <div
                        className={`SupportTicketTable-body-name ${"cursor-pointer"}`}
                        onClick={() => handleAnswer(i.id)}
                    >
                        {i.subject}
                    </div>
                    <div>
                        {moment(i.created_at)
                            .locale("fa", { useGregorianParser: true })
                            .format("HH:mm:ss YYYY/MM/DD")}
                    </div>
                    <div>
                        {i.is_seen ? (
                            <p className="SupportTicketTable-body-checked">
                                بررسی شده
                            </p>
                        ) : (
                            <p className="SupportTicketTable-body-notchecked">
                                بررسی نشده
                            </p>
                        )}
                    </div>
                    {/* <div>
                        {!i.is_seen && (
                            <div className="flex">
                                <div>
                                    <IconButton data-tip="بارگزاری مجدد">
                                        <ReFetch />
                                    </IconButton>
                                </div>
                                <div>
                                    <IconButton data-tip="ویرایش">
                                        <Edit />
                                    </IconButton>
                                </div>
                            </div>
                        )}
                    </div> */}
                </Card>
            ))}

            <Modal show={edit}>
                <TicketModal
                    close={setEdit}
                    data={modalData}
                    method="put"
                    id={1}
                />
            </Modal>
        </div>
    );
};

export default SupportTicketTable;
